import apiFetch from "core/fetch/apiFetch";
import BookingFilter from "./bookingFilter";
import { MemberViewModel } from "./member";

const _baseEndPoint = "broadcasts";

interface BroadcastInput {
    subject: string;
    content: string;
}

interface BroadcastViewModel {
    id: number;
    sentDate: Date;
    subject: string;
    content: string;
    recipients: string;
}

export default class Booking {
    static getDefaultInput(): BroadcastInput {
        return ({
            subject: "",
            content: ""
        });
    }
    static async search(filter = new BookingFilter(), page: number): Promise<BroadcastViewModel[]> {
        filter.setPaginationParameters(page);
        return await apiFetch(`${_baseEndPoint}?${filter.toQueryString()}`);
    }
    static create(item: BroadcastInput): Promise<BroadcastInput> {
        const sanitizedItem: BroadcastInput = {
            ...item,
            content: item.content.replace(/\n/g, "<br>")
        };
        return apiFetch(_baseEndPoint, "POST", sanitizedItem);
    }
    static async getRecipients(): Promise<MemberViewModel> {
        return await apiFetch(`${_baseEndPoint}/recipients`);
    }
}
